var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { attrs: { "no-body": "" } },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center mb-1" },
            [
              _c("b-spinner", {
                staticStyle: { width: "3rem", height: "3rem" },
                attrs: { variant: "success", label: "Spinning", block: "" },
              }),
            ],
            1
          )
        : _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "mb-3", attrs: { md: "6", sm: "12" } },
                [
                  _c("h6", [_vm._v("Chosen Fields")]),
                  _c(
                    "draggable",
                    {
                      staticClass: "list-group",
                      attrs: { list: _vm.chosenFields, group: "people" },
                      on: { change: _vm.log },
                    },
                    _vm._l(_vm.chosenFields, function (element) {
                      return _c(
                        "div",
                        {
                          key: element.key,
                          staticClass: "list-group-item custom-list-item",
                        },
                        [_vm._v(" " + _vm._s(element.displayValue) + " ")]
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { staticClass: "mb-3", attrs: { md: "6", sm: "12" } },
                [
                  _c("h6", [_vm._v("Field Options")]),
                  _c(
                    "draggable",
                    {
                      staticClass: "list-group",
                      attrs: { list: _vm.availableFields, group: "people" },
                      on: { change: _vm.log },
                    },
                    _vm._l(_vm.availableFields, function (element) {
                      return _c(
                        "div",
                        {
                          key: element.key,
                          staticClass: "list-group-item custom-list-item",
                        },
                        [_vm._v(" " + _vm._s(element.displayValue) + " ")]
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                {
                  staticClass: "d-flex justify-content-end",
                  attrs: { md: "12", sm: "12" },
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-1",
                      attrs: { variant: "primary" },
                      on: { click: _vm.saveConfigurations },
                    },
                    [_vm._v("Save")]
                  ),
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "b-modal",
                          rawName: "v-b-modal.invoice-preview",
                          modifiers: { "invoice-preview": true },
                        },
                      ],
                      attrs: { variant: "secondary" },
                    },
                    [_vm._v("Preview")]
                  ),
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  attrs: {
                    id: "invoice-preview",
                    "ok-only": "",
                    "ok-title": "Ok",
                    centered: "",
                    size: "xl",
                    title: "Invoice Preview",
                  },
                },
                [
                  _c("InvoiceTemplate", {
                    attrs: {
                      custAddress: _vm.isFieldChosen("CustomerAddress"),
                      custName: _vm.isFieldChosen("CustomerName"),
                      dueDate: _vm.isFieldChosen("DueDate"),
                      invoiceDate: _vm.isFieldChosen("InvoiceDate"),
                      invoiceNo: _vm.isFieldChosen("InvoiceNumber"),
                      notes: _vm.isFieldChosen("Notes"),
                      paymentTerms: _vm.isFieldChosen("PaymentTerms"),
                      salesRep: _vm.isFieldChosen("SalesRep"),
                      taxAmount: _vm.isFieldChosen("TaxAmount"),
                      totalAmount: _vm.isFieldChosen("TotalAmount"),
                      productImage: _vm.isFieldChosen("ProductImage"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }